var _defs, _use, _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMallMarketing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mall-marketing_svg__a",
    d: "M12.1 10h.6c.2 0 .3.1.3.3v3.1c0 .2-.1.3-.3.3h-.6c-.2 0-.3-.1-.3-.3v-3.1c0-.2.1-.3.3-.3zM3.4 8h11.2V6H3.4v2zm10.4 1.1H4.2v4.8c0 .3.3.6.6.6h8.4c.3 0 .6-.3.6-.6V9.1zm-2.1-4.2c.5 0 .7-.2.7-.7 0-.4-.4-.7-1-.7-.2 0-.6.2-1 .6-.3.3-.5.6-.6.8h1.9zm-7.1 0c-.1-.2-.1-.4-.1-.7 0-1 1-1.8 2.1-1.8.8 0 1.9.9 2.4 1.7.5-.9 1.6-1.7 2.4-1.7 1.1 0 2.1.8 2.1 1.8 0 .3 0 .5-.1.7h1.2c.6 0 1.1.5 1.1 1.1v2c0 .5-.4 1-.8 1.1v4.8c0 .9-.8 1.7-1.7 1.7H4.8c-.9 0-1.7-.8-1.7-1.7V9.1c-.5-.1-.9-.6-.9-1.1V6c0-.6.5-1.1 1.1-1.1h1.3zm3.5 0c0-.1-.2-.5-.5-.8-.4-.4-.8-.6-1-.6-.6 0-1 .3-1 .7 0 .5.2.7.7.7h1.8z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-marketing_svg__a",
    overflow: "visible"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "mall-marketing_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-marketing_svg__a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mall-marketing_svg__b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mall-marketing_svg__c",
    d: "M-1010-847.1H414v1785h-1424z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mall-marketing_svg__c",
    overflow: "visible"
  }))));
}

export default SvgMallMarketing;